module.exports = __webpack_public_path__ + "assets/img/2e44-sv.svg";